import { TaskListQuery } from "@common/contracts/task.contract";
import { FiltersTypes } from "@common/types/filters/general";
import { parseDateOnly } from "@design-system/DatePicker/DatePicker.lib";

export function taskListQueryToOverlayFilters(
    query: TaskListQuery | undefined,
): FiltersTypes {
    if (!query) {
        return {};
    }

    return {
        taskAssigneeIds: query.assigneeIds,
        isTaskUnassigned: query.isUnassigned,
        isTaskAssignedToClient: query.isAssignedToClient,
        taskCreatedByIds: query.createdByIds,
        isTaskCreatedByClient: query.isCreatedByClient,
        taskClientIds: query.clientIds,
        taskCreatedAtStart: parseDateOnly(query.createdAtStart),
        taskCreatedAtEnd: parseDateOnly(query.createdAtEnd),
        taskCompletedByIds: query.completedByIds,
        taskCompletedAtStart: parseDateOnly(query.completedAtStart),
        taskCompletedAtEnd: parseDateOnly(query.completedAtEnd),
        taskCloseIds: query.closeIds,
        taskPriorities: query.priorities,
        hasAttachments: query.hasAttachments,
        taskGroupIds: query.taskGroupIds,
        hasBlockedBy: query.hasBlockedBy,
        hasBlocking: query.hasBlocking,
        hasRelated: query.hasRelated,
        hasUnreadChat: query.hasUnreadChat,
        taskCloseStageIds: query.taskCloseStageIds,
    };
}
